import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function PatentPortfolio({ patentPortfolio }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     x_of_active_patents: "b",
  //     focus_areas: "c",
  //     recent_filings: "d",
  //     x_of_active_patents_positive_insight: "b",
  //     x_of_active_patents_negative_insight: "b",
  //     x_of_active_patents_recent_development: "b",
  //     focus_areas_positive_insight: "c",
  //     focus_areas_negative_insight: "c",
  //     focus_areas_recent_development: "c",
  //     recent_filings_positive_insight: "d",
  //     recent_filings_negative_insight: "d",
  //     recent_filings_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     x_of_active_patents: "b",
  //     focus_areas: "c",
  //     recent_filings: "d",
  //     x_of_active_patents_positive_insight: "b",
  //     x_of_active_patents_negative_insight: "b",
  //     x_of_active_patents_recent_development: "b",
  //     focus_areas_positive_insight: "c",
  //     focus_areas_negative_insight: "c",
  //     focus_areas_recent_development: "c",
  //     recent_filings_positive_insight: "d",
  //     recent_filings_negative_insight: "d",
  //     recent_filings_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     x_of_active_patents: "b",
  //     focus_areas: "c",
  //     recent_filings: "d",
  //     x_of_active_patents_positive_insight: "b",
  //     x_of_active_patents_negative_insight: "b",
  //     x_of_active_patents_recent_development: "b",
  //     focus_areas_positive_insight: "c",
  //     focus_areas_negative_insight: "c",
  //     focus_areas_recent_development: "c",
  //     recent_filings_positive_insight: "d",
  //     recent_filings_negative_insight: "d",
  //     recent_filings_recent_development: "d",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(patentPortfolio);
    setTabData(tableData);
  }, [patentPortfolio]);

  const tableColumns = [
    // { id: "competitor", label: "Competitor" },
    { key: "number_of_active_patents", label: "Number Of Active Patents" },
    { key: "focus_areas", label: "Focus Areas" },
    { key: "recent_filings", label: "Recent Filings" },
  ];

  return (
    <InsightTable
      title="Patent Portfolio"
      subtitle="An overview of each company's patent holdings, innovation areas, and recent IP filings that support product differentiation and defensibility."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default PatentPortfolio;
